import type { ReploSimpleProjectWithStats } from "schemas/generated/project";

import * as React from "react";

import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import { AppWindow, FileText, Rows, ShoppingCart } from "lucide-react";

type StatItemProps = {
  icon: React.ReactNode;
  count: number | undefined;
  tooltip: string;
  isLast?: boolean;
};

const StatItem: React.FC<StatItemProps> = ({
  icon,
  count,
  tooltip,
  isLast,
}) => (
  <Tooltip content={tooltip} triggerAsChild>
    <div className="text-muted flex cursor-default items-center gap-1 text-xs">
      {icon}
      <span>{count ?? 0}</span>
      {!isLast && <span className="text-muted mx-0.5">|</span>}
    </div>
  </Tooltip>
);

type StatSectionProps = {
  elementCounts: ReploSimpleProjectWithStats["elementCounts"];
};

const StatSection: React.FC<StatSectionProps> = ({ elementCounts }) => {
  return (
    <div className="flex flex-row items-center gap-0.5">
      <StatItem
        icon={<AppWindow size={12} />}
        count={elementCounts?.pageCount}
        tooltip={`${elementCounts?.pageCount ?? 0} ${elementCounts?.pageCount === 1 ? "Page" : "Pages"} Published`}
      />
      <StatItem
        icon={<ShoppingCart size={12} />}
        count={elementCounts?.productTemplateCount}
        tooltip={`${elementCounts?.productTemplateCount ?? 0} ${elementCounts?.productTemplateCount === 1 ? "Product Template" : "Product Templates"} Published`}
      />
      <StatItem
        icon={<Rows size={12} />}
        count={elementCounts?.sectionCount}
        tooltip={`${elementCounts?.sectionCount ?? 0} ${elementCounts?.sectionCount === 1 ? "Section" : "Sections"} Published`}
      />
      <StatItem
        icon={<FileText size={12} />}
        count={elementCounts?.blogCount}
        tooltip={`${elementCounts?.blogCount ?? 0} ${elementCounts?.blogCount === 1 ? "Blog" : "Blogs"} Published`}
        isLast
      />
    </div>
  );
};

export default StatSection;
